import { g } from '@hcie/core';
import type { VectorEditContext } from './types';

export type HandleId = 'n' | 's' | 'e' | 'w' | 'nw' | 'ne' | 'sw' | 'se';
export type HandleDir = { x: number; y: number };

export function handleDir(handle: HandleId): HandleDir {
    switch (handle) {
        case 'n': return { x: 0, y: -1 };
        case 's': return { x: 0, y: 1 };
        case 'e': return { x: 1, y: 0 };
        case 'w': return { x: -1, y: 0 };
        case 'ne': return { x: 1, y: -1 };
        case 'nw': return { x: -1, y: -1 };
        case 'se': return { x: 1, y: 1 };
        case 'sw': return { x: -1, y: 1 };
    }
}

export function getZoom(ctx?: VectorEditContext) {
    return ctx?.zoom ?? (g.zoom || 1);
}

export function getCanvasWrapper() {
    return document.getElementById('canvasWrapper') as HTMLElement | null;
}

export function getScrollArea() {
    return document.getElementById('canvasScrollArea') as HTMLElement | null;
}

